import React from 'react';
import { ScrollView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Separator } from 'src/components/Separator';
import { GroupHeader } from 'src/components/GroupHeader';
import { Group } from 'src/components/Group';
import { Link } from 'src/components/Link';
import { Counter } from 'src/components/Counter';

storiesOf('GroupHeader', module).add('Default', () => (
  <ScrollView>
    <PanelHeader separator={<Separator line />}>📰 GroupHeader</PanelHeader>
    <Group>
      <GroupHeader>Favorites</GroupHeader>
      <GroupHeader subtitle="5377 cards" aside={<Link>Show all</Link>}>
        Collections
      </GroupHeader>
      <GroupHeader
        indicator={
          <Counter variant="prominent" size="s">
            3
          </Counter>
        }
        aside={<Link>Show all</Link>}
      >
        Pending invitations
      </GroupHeader>
    </Group>
    <Group>
      <GroupHeader variant="secondary" aside={<Link>Show all</Link>}>
        Favorites
      </GroupHeader>
      <GroupHeader
        variant="secondary"
        aside={<Link>Show all</Link>}
        indicator={
          <Counter variant="primary" size="s">
            1
          </Counter>
        }
      >
        New cards
      </GroupHeader>
      <GroupHeader variant="secondary" aside={<Link>Show all</Link>}>
        Card collections
      </GroupHeader>
    </Group>
  </ScrollView>
));
